import { Component, OnInit, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaInstallService } from '../../services/pwa-install.service';

@Component({
  selector: 'app-pwa-install',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="pwaInstallService.showInstallPrompt()" class="install-banner" [class.pulsing]="pulsing">
      <div class="install-content">
        <div class="message-container">
          <h3>Install Core KSA Backoffice</h3>
          <p>Install this app on your device for better experience.</p>
          <div class="benefits">
            <span>✓ Fast access</span>
            <!-- <span>✓ Works offline</span> -->
            <span>✓ No installation from app stores</span>
          </div>
        </div>
        <div class="actions">
          <button class="install-btn" (click)="installPwa()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14"></path>
            </svg>
            Install Now
          </button>
          <button class="close-btn" (click)="dismissPrompt()">×</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .install-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 999;
      background-color: #333333;
      color: white;
      padding: 20px;
      display: flex;
      justify-content: center;
      box-shadow: 0 -2px 15px rgba(0,0,0,0.3);
      transition: all 0.3s ease;
      animation: slideUp 0.5s forwards;
    }

    @keyframes slideUp {
      from { transform: translateY(100%); }
      to { transform: translateY(0); }
    }

    .install-banner.pulsing {
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0% { box-shadow: 0 -2px 15px rgba(0,0,0,0.3); }
      50% { box-shadow: 0 -2px 25px rgba(206, 161, 118, 0.7); }
      100% { box-shadow: 0 -2px 15px rgba(0,0,0,0.3); }
    }

    .install-content {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      max-width: 1200px;
      width: 100%;
      flex-wrap: wrap;
    }

    .message-container {
      flex: 1;
      min-width: 280px;
    }

    h3 {
      margin: 0 0 8px 0;
      font-size: 1.3rem;
    }

    p {
      margin: 0 0 12px 0;
      opacity: 0.9;
    }

    .benefits {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }

    .benefits span {
      font-size: 0.9rem;
      opacity: 0.8;
    }

    .actions {
      display: flex;
      align-items: center;
      margin-top: 16px;
    }

    .install-btn {
      background-color: #cea176;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 10px 18px;
      margin-left: 16px;
      cursor: pointer;
      font-weight: bold;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: background-color 0.3s;
    }

    .install-btn:hover {
      background-color: #d9ad85;
    }

    .close-btn {
      background: none;
      color: white;
      font-size: 28px;
      padding: 0 12px;
      margin-left: 12px;
      cursor: pointer;
      border: none;
    }

    @media (max-width: 600px) {
      .install-content {
        flex-direction: column;
      }

      .actions {
        margin-top: 16px;
        width: 100%;
        justify-content: flex-end;
      }
    }
  `]
})
export class PwaInstallComponent implements OnInit {
  pulsing = false;
  
  constructor(public pwaInstallService: PwaInstallService) {}
  
  ngOnInit() {
    // Start pulsing effect after a short delay to draw attention
    setTimeout(() => {
      this.pulsing = true;
      
      // Stop pulsing after a few seconds so it's not too annoying
      setTimeout(() => {
        this.pulsing = false;
      }, 6000);
    }, 2000);
    
    // Log installation status for debugging
    if (isDevMode()) {
      // console.log('PWA Installation Component initialized');
      // console.log('Install prompt visible:', this.pwaInstallService.showInstallPrompt());
      // console.log('Is standalone:', this.pwaInstallService.isStandalone);
    }
  }

  installPwa() {
    // console.log('Install button clicked');
    this.pwaInstallService.promptInstall();
  }

  dismissPrompt() {
    // console.log('Install prompt dismissed');
    this.pwaInstallService.showInstallPrompt.set(false);
  }

  // Debug methods (only in development)
  async logPWAStatus() {
    if (isDevMode()) {
      const status = await this.pwaInstallService.getPWAStatus();
      console.table(status);
    }
  }

  forceShowPrompt() {
    if (isDevMode()) {
      this.pwaInstallService.forceShowInstallPrompt();
    }
  }
}
